export default "__VITE_ASSET__Dvnm2Dxq__"